import './style.scss';
import * as bootstrap from 'bootstrap'
import PageTransitionExtension from './PageTransitionExtension';
/*import LoadingIndicatorExtension from './LoadingIndicatorExtension';*/
import naja from 'naja';

naja.uiHandler.selector = ':not(.noajax):not(form):not(input):not([href^="#"])'; // nez mezery  ":not(.noajax):not(form)"
naja.registerExtension(new PageTransitionExtension('.mainContent', {
    loadingClass: 'is-loading'
}));
naja.initialize();

//import netteForms from 'nette-forms';
//naja.formsHandler.netteForms = netteForms;
import 'animate.css';

import {LiveForm, Nette} from 'live-form-validation';

LiveForm.setOptions({
    controlValidClass: 'is-valid',
    showValid: true,
    controlErrorClass: 'is-invalid',
    messageErrorClass: 'invalid-feedback'
});
window.Nette = Nette;
window.LiveForm = LiveForm;
Nette.initOnLoad();

/*
import noUiSlider from "nouislider";

import {max, round} from "@popperjs/core/lib/utils/math";


/*
function offerFilter() {
    const filters = document.querySelectorAll('#offer-filter select, #offer-filter input');
    filters.forEach(function (item, idx,) {
        item.addEventListener('change', function (event) {
            naja.uiHandler.submitForm(event.target.form);
        })
    })
}*/

import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss'

const flashes = document.getElementById('snippet--flashMessage');

function flashMessage() {
    let content = flashes.textContent;
    let type = 'success';
    if (content.trim() !== '') {
        flashes.style.display = 'none';
        content = content
            .replace('.', '.$', content)
            .replace(',', ',$', content);
        console.log(content);
        content = content.trim().split('$', 2);
        console.log(content);
        Swal.fire({
            title: content[0],
            text: content[1],
            icon: type,
            confirmButtonText: 'Zavřít',
            confirmButtonColor: '#3085d6',
        });
    }
}

flashes.addEventListener('change', () => {
    flashMessage();
});
flashMessage();

// reveal - animace karet produktů, buď při najetí a nebo při scrollování
function reveal() {
    var reveals = document.querySelectorAll("[data-scroll-animation]");

    for (let i = 0; i < reveals.length; i++) {
        const windowHeight = window.innerHeight;
        const elementPositionTop = reveals[i].getBoundingClientRect().top;

        const elementHeight = reveals[i].offsetHeight

        const elementVisibleManualOffset = 0;
        const addClasses = reveals[i].getAttribute('data-scroll-animation').split(' ');

        reveals[i].style.transform = 'translate3d(100vw, 0, 0)';

        if (elementPositionTop < windowHeight - elementVisibleManualOffset) {
            reveals[i].classList.add(...addClasses);
        } else {
            //reveals[i].classList.remove("active");
        }
    }
}

reveal();
window.addEventListener("scroll", reveal);
naja.addEventListener('complete', reveal);


function navBarShrink() {
    window.addEventListener("scroll", function () {
        const navbar = document.getElementById("nav");
        const nav_classes = navbar.classList;
        if (document.documentElement.scrollTop >= 120) {
            if (nav_classes.contains("shrink") === false) {
                nav_classes.toggle("shrink");
            }
        } else if (document.documentElement.scrollTop <= 10) {
            if (nav_classes.contains("shrink") === true) {
                nav_classes.toggle("shrink");
            }
        }
    })
}

navBarShrink();

//const navLinks = document.querySelectorAll('.nav-item');
const menuToggle = document.getElementById('nav-collapse');
const bsCollapse = new bootstrap.Collapse(menuToggle, {toggle: false});
$(document).on('click', '.nav-item', function (event) {
    bsCollapse.hide()
});

/** Enable tooltips*/
function enableTooltips() {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
}

enableTooltips();
naja.addEventListener('complete', enableTooltips);


import {createApp} from 'vue';
import Calculator from './Calculator';

function calculatorInit() {
    const rows = document.querySelectorAll('#products tbody tr');
    if (rows.length > 0) {
        rows[0].classList.add("active");
        rows[0].querySelectorAll("input")[0].checked = true;
        rows.forEach((row) => {
            row.addEventListener('click', () => {
                const current = document.querySelectorAll('#products .active');
                if (current.length > 0) {
                    current[0].classList.remove("active");
                    current[0].querySelectorAll("input")[0].checked = false;
                }
                row.classList.add("active");
                row.querySelectorAll("input")[0].checked = true;
            });
        });

        const app = createApp(Calculator);
        app.mount('#vue-calculator');
    }
}

calculatorInit();
import OfferFilter from "@/front/OfferFilter.vue";

let app;

function offerFilterInit() {
    app = createApp(OfferFilter);
    // app.use(VueRouter);
    app.mount('#vue-offerFilter');
}

offerFilterInit();
/*document.getElementsByClassName('offer-filter_reset')[0].addEventListener('click', function (e) {
    const instance = app._instance; // Získání instance Vue aplikace
    if (instance && instance.proxy) {
        instance.proxy.resetFilter(); // Volání metody resetFilter
    }
});*/
const resetBtn = document.querySelector('.offer-filter_reset');

// Funkce pro kontrolu stavu filtru a přidání/odebrání třídy "disabled" z tlačítka reset
function updateResetButtonState() {
    const filterActive = app._instance.proxy.filterApplied; // Kontrola stavu filtru
    if (filterActive) {
        resetBtn.classList.remove('disabled');
    } else {
        resetBtn.classList.add('disabled');
    }
}

// Volání funkce při načtení stránky pro nastavení počátečního stavu tlačítka
updateResetButtonState();
// Přidání posluchače události pro aktualizaci stavu tlačítka
resetBtn.addEventListener('click', function (e) {
    app._instance.proxy.resetFilter(); // Volání metody resetFilter
    updateResetButtonState(); // Aktualizace stavu tlačítka po stisknutí
});

/*
import OfferFilerSlider from "./_offerFilterSlider";
OfferFilerSlider();*/

import OfferFilterOthers from "./_offerFilter";

OfferFilterOthers();
//offerFilter();*/
naja.addEventListener('complete', () => {
    // OfferFilerSlider();
    /*
     OfferFilter();
     //offerFilter();*/

    offerFilterInit();
    calculatorInit();
    OfferFilterOthers();
});
